module.exports = __webpack_public_path__ + "static/media/ImsightSoftwareLicenseAgreenment.9721a935.pdf";